<template>
    <div class="contacts">
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Ad Soyad</th>
                                        <th>Telefon</th>
                                        <th>Mesaj</th>
                                        <th>Tarih</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.phone }}</td>
                                        <td>{{ item.message | truncate }}</td>
                                        <td>{{ item.created_at }}</td>
                                        <td>
                                            <router-link :to="{ name: 'contacts.show', params: {id: item.id} }" class="btn btn-primary btn-xs">  <span>Göster</span></router-link> / <button class="btn btn-danger btn-xs">Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="10" @paginate="fetchPosts()"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/layouts/Pagination'
    export default {
        components: { Pagination },
        data () {
            return {
                tableName: 'İletişim Formu Tablosu',
                icon: 'fa fa-envelope',
                tableDesc: '',
                api: 'contacts',
                items: [],
                pagination: {
                    'current_page': 1
                }
            }
        },
        mounted () {
            this.fetchPosts()
        },
        methods: {
            fetchPosts() {
                this.$Progress.start()
                this.axios.get(this.api, { params: {
                    page: this.pagination.current_page,
                }}).then(response => {
                    this.pagination = response.data.pagination;
                    this.items = response.data.data.data
                    this.$Progress.finish()
                })
            },
        },
        filters: {
            truncate: function (value) {
                if(value.length > 70) {
                    value = value.substring(0, 70) + '...';
                }
                return value;
            }
        }
    }
</script>

<style scoped>

</style>
